import React, { useState, useEffect } from 'react';

const PWAInstallPrompt = () => {
    const [installPrompt, setInstallPrompt] = useState(null);
    const [isIOS, setIsIOS] = useState(false);
    const [isStandalone, setIsStandalone] = useState(false);

    useEffect(() => {
        // Check if already installed / standalone
        const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
        setIsStandalone(standalone);

        // Check if iOS
        const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        setIsIOS(ios);

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setInstallPrompt(e);
            
            // Show prompt after a short delay if not already shown this session
            if (!sessionStorage.getItem('pwa_prompt_shown') && !standalone) {
                showPrompt(e);
            }
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        // iOS specific prompt (manual instructions)
        if (ios && !standalone && !sessionStorage.getItem('pwa_prompt_shown')) {
            setTimeout(() => showIOSPrompt(), 3000);
        }

        return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    }, []);

    const showPrompt = (e) => {
        sessionStorage.setItem('pwa_prompt_shown', 'true');
        window.Swal.fire({
            title: 'Installa Solteros',
            text: 'Vuoi installare l\'app sul tuo smartphone per un accesso più veloce e un\'esperienza migliore?',
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Installa Ora',
            cancelButtonText: 'Più tardi',
            confirmButtonColor: '#db2777',
            customClass: {
                popup: 'swal2-glass rounded-5',
                confirmButton: 'rounded-pill px-4',
                cancelButton: 'rounded-pill px-4'
            }
        }).then((result) => {
            if (result.isConfirmed && e) {
                e.prompt();
                e.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        console.log('User accepted the install prompt');
                    }
                    setInstallPrompt(null);
                });
            }
        });
    };

    const showIOSPrompt = () => {
        sessionStorage.setItem('pwa_prompt_shown', 'true');
        window.Swal.fire({
            title: 'Installa Solteros',
            html: `
                <div class="text-start">
                    <p>Per installare l'app sul tuo iPhone:</p>
                    <ol>
                        <li>Tocca l'icona <strong>Condividi</strong> <i class="fas fa-external-link-alt text-primary"></i> in basso.</li>
                        <li>Scorri e seleziona <strong>"Aggiungi alla schermata Home"</strong> <i class="fas fa-plus-square text-primary"></i>.</li>
                    </ol>
                </div>
            `,
            icon: 'info',
            confirmButtonText: 'Ho capito',
            confirmButtonColor: '#db2777',
            customClass: {
                popup: 'swal2-glass rounded-5',
                confirmButton: 'rounded-pill px-4'
            }
        });
    };

    if (isStandalone) return null;

    return (
        <div className="text-center mt-5 mb-3 fade-in" style={{ opacity: 0.8 }}>
            <button 
                className="btn btn-link btn-sm text-pink-600 fw-900 text-decoration-none ls-lg" 
                onClick={() => isIOS ? showIOSPrompt() : (installPrompt ? showPrompt(installPrompt) : showPrompt(null))}
                style={{ fontSize: '0.7rem', textTransform: 'uppercase' }}
            >
                <i className="fas fa-download me-2"></i>
                Installa App Solteros
            </button>
        </div>
    );
};

export default PWAInstallPrompt;
